export default {
  title: 'Exclusive Offers',
  header: {
    back: 'Back',
    title: 'Rewards',
  },
  info: {
    title: 'You have {{points}} points.',
    description: 'Spend {{amount}} to get 5 points! Add items to your cart for free with your earned points.',
  },
  rewards: {
    data: [
      {
        title: 'Earn Points for Every Order',
        description: 'Every {{amount}} you spend adds 5 points to your account.',
      },
      {
        title: 'Earn Points for Every Order',
        description:
          'Redeem your points for free goodies! Start earning points at 350 points, which is equivalent to spending {{amount}}.',
      },
      {
        title: 'Earn Points for Every Order',
        description:
          'Discover exclusive offers, promotions and discounts. Check out member-only promotions in the app.',
      },
    ],
  },
};
